import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="bg-[#090a0f] text-slate-100 min-h-[75vh] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-20">
      <Helmet>
        <title>403 - Adgang Nægtet - Foreningen ØrBike</title>
      </Helmet>

      <div className="max-w-xl mx-auto text-center space-y-6">
        <div className="inline-block px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider bg-red-500/20 text-red-400 border border-red-500/40">
          Fejl 403
        </div>

        <h1 className="text-6xl sm:text-8xl font-black font-display text-white tracking-tight leading-none text-red-500">
          ADGANG NÆGTET
        </h1>

        <p className="text-xl sm:text-2xl font-bold font-display text-slate-200 uppercase">
          Du har ikke tilladelse til at se dette område
        </p>

        <p className="text-slate-400 text-sm max-w-md mx-auto leading-relaxed">
          Dette område er forbeholdt arrangører eller kræver særlig adgangstilladelse. Du kan i stedet vende tilbage til de åbne sektioner:
        </p>

        <div className="pt-4 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="px-6 py-3 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold text-xs uppercase tracking-wider shadow-lg hover:scale-105 transition-transform"
          >
            <i className="fa-solid fa-house mr-1.5" aria-hidden="true"></i>
            <span>Gå til Forsiden</span>
          </Link>
          <Link
            to="/eventet"
            className="px-6 py-3 rounded-full bg-slate-900 border border-slate-700 hover:border-pink-500/50 text-white font-bold text-xs uppercase tracking-wider transition-colors"
          >
            <span>Se Eventet</span>
          </Link>
          <Link
            to="/billetter"
            className="px-6 py-3 rounded-full bg-slate-900 border border-slate-700 hover:border-pink-500/50 text-white font-bold text-xs uppercase tracking-wider transition-colors"
          >
            <span>Køb Billet</span>
          </Link>
          <Link
            to="/kontakt"
            className="px-6 py-3 rounded-full bg-slate-900 border border-slate-700 hover:border-pink-500/50 text-white font-bold text-xs uppercase tracking-wider transition-colors"
          >
            <span>Kontakt ØrBike</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
